/* joacă bună — header drawer mobil. Vanilla, accesibil (Esc, overlay, scroll lock, focus). */
(function () {
  'use strict';
  const header = document.querySelector('[data-jb-header]');
  if (!header) return;
  const drawer = header.querySelector('.jb-header__drawer');
  const overlay = header.querySelector('.jb-header__overlay');
  const burger = header.querySelector('[data-drawer-toggle]');
  let lastFocus = null;

  // înălțimea reală a barei (poate varia cu lățimea logo-ului) — drawer-ul și
  // overlay-ul pornesc de sub ea (top), ca să nu o mai acopere niciodată. Restul
  // înălțimii disponibile e calculat de browser din top+bottom:0 (CSS pur, fără
  // vh/dvh) — nu depinde de suportul pentru unități de viewport, deci nu se mai
  // poate rupe pe dispozitive/browsere unde 100dvh nu se calculează corect.
  function syncHeaderHeight() {
    const h = header.getBoundingClientRect().height;
    if (h > 0) header.style.setProperty('--jb-header-h', h + 'px');
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);

  function open() {
    syncHeaderHeight();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => header.setAttribute('data-open', ''));
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Închide meniul');
    document.documentElement.style.overflow = 'hidden';
    const first = drawer.querySelector('button, a, input');
    if (first) first.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    header.removeAttribute('data-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Deschide meniul');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    const onEnd = () => { drawer.hidden = true; overlay.hidden = true; drawer.removeEventListener('transitionend', onEnd); };
    drawer.addEventListener('transitionend', onEnd);
    setTimeout(onEnd, 350); // fallback
    if (lastFocus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  burger && burger.addEventListener('click', () => {
    if (header.hasAttribute('data-open')) close(); else open();
  });
  header.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
  // închide la navigare către un link din drawer
  drawer.querySelectorAll('a[href]').forEach((a) => a.addEventListener('click', close));

  // micro-moment: triunghiul din logo — squash de plastilină la tap
  const logoLink = header.querySelector('[data-jb-logo-link]');
  const logoTriangle = logoLink && logoLink.querySelector('[data-jb-logo-triangle]');
  if (logoLink && logoTriangle) {
    logoTriangle.addEventListener('animationend', () => logoTriangle.classList.remove('is-squashing'));
    logoLink.addEventListener('click', () => {
      logoTriangle.classList.remove('is-squashing');
      void logoTriangle.offsetWidth; // reflow — permite re-declanșarea la tap-uri rapide
      logoTriangle.classList.add('is-squashing');
      if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && navigator.vibrate) {
        navigator.vibrate(10);
      }
    });
  }
})();